import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const WARD_PATH = "/ward/v1";

export const getWardApi = async (params) => await getRequest(WARD_PATH, params);

export const getWardByIdApi = async (id) =>
  await getRequest(`${WARD_PATH}/${id}`);

export const addWardApi = async (data) => await postRequest(WARD_PATH, data);

export const updateWardApi = async (id, data) => await putRequest(`${WARD_PATH}/${id}`, data);

export const deleteWardByIdApi = async (id) => await deleteRequest(`${WARD_PATH}/${id}`);
